"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'tree-select',
  props: {
    // 树结构数据
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    defaultProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 配置是否可多选
    multiple: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    nodeKey: {
      type: String,
      default: function _default() {
        return 'id';
      }
    },
    // 显示复选框情况下，是否严格遵循父子不互相关联
    checkStrictly: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 默认选中的节点key数组
    checkedKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    width: {
      type: Number,
      default: function _default() {
        return 250;
      }
    },
    height: {
      type: Number,
      default: function _default() {
        return 300;
      }
    }
  },
  data: function data() {
    return {
      defaultCheckedKeys: [],
      isShowSelect: false,
      // 是否显示树状选择器
      options: [],
      selectedData: [],
      // 选中的节点
      style: 'width:' + this.width + 'px;' + 'height:' + this.height + 'px;',
      selectStyle: 'width:' + (this.width + 24) + 'px;',
      checkedIds: [],
      checkedData: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    if (this.checkedKeys.length > 0) {
      if (this.multiple) {
        this.defaultCheckedKeys = this.checkedKeys;
        this.selectedData = this.checkedKeys.map(function (item) {
          var node = _this.$refs.tree.getNode(item);
          return node.label;
        });
      } else {
        var item = this.checkedKeys[0];
        this.$refs.tree.setCurrentKey(item);
        var node = this.$refs.tree.getNode(item);
        this.selectedData = node.label;
      }
    }
  },
  methods: {
    popoverHide: function popoverHide() {
      if (this.multiple) {
        this.checkedIds = this.$refs.tree.getCheckedKeys(); // 所有被选中的节点的 key 所组成的数组数据
        this.checkedData = this.$refs.tree.getCheckedNodes(); // 所有被选中的节点所组成的数组数据
      } else {
        this.checkedIds = this.$refs.tree.getCurrentKey();
        this.checkedData = this.$refs.tree.getCurrentNode();
      }
      this.$emit('popoverHide', this.checkedIds, this.checkedData);
    },
    // 节点被点击时的回调,返回被点击的节点数据
    handleNodeClick: function handleNodeClick(data, node) {
      if (!this.multiple) {
        var tmpMap = {};
        tmpMap.value = node.key;
        tmpMap.label = node.label;
        this.options = [];
        this.options.push(tmpMap);
        this.selectedData = node.label;
        this.isShowSelect = !this.isShowSelect;
      }
    },
    // 节点选中状态发生变化时的回调
    handleCheckChange: function handleCheckChange() {
      var _this2 = this;
      var checkedKeys = this.$refs.tree.getCheckedKeys(); // 所有被选中的节点的 key 所组成的数组数据
      this.options = checkedKeys.map(function (item) {
        var node = _this2.$refs.tree.getNode(item); // 所有被选中的节点对应的node
        var tmpMap = {};
        tmpMap.value = node.key;
        tmpMap.label = node.label;
        return tmpMap;
      });
      this.selectedData = this.options.map(function (item) {
        return item.label;
      });
    }
  },
  watch: {
    isShowSelect: function isShowSelect(val) {
      // 隐藏select自带的下拉框
      this.$refs.select.blur();
    }
  }
};